import script from "./login-welcome.vue?vue&type=script&setup=true&lang=ts"
export * from "./login-welcome.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__